import React, { useState, useCallback } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { RiCloseLine } from 'react-icons/ri';

import { useToast } from '../../../../hooks/toast';
import { useRegisterAdded } from '../../../../hooks/registerAdded';

import { ModalWrapper, MenuOptionButton } from '../styles';
import api from '../../../../services/api';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '70%',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #757575',
      borderRadius: '6px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 0, 3),
    },
  }),
);

interface DeleteProductProps {
  produto_id: number;
  descricao: string;
  tipo_produto: number;
}

const DeleteProductOption: React.FC<DeleteProductProps> = ({
  produto_id,
  descricao,
  tipo_produto,
}) => {
  const [open, setOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const classes = useStyles();

  const { addToast } = useToast();
  const { handleSetHasProductUpdated } = useRegisterAdded();

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleDeleteProduct = useCallback(async () => {
    try {
      setIsDisabled(true);
      await api.delete(`/produto/${produto_id}`);

      addToast({
        type: 'success',
        title: `O produto ${descricao} foi excluído.`,
      });

      handleSetHasProductUpdated(true);
      handleClose();
      setIsDisabled(false);
    } catch (err) {
      const { message } = err.response.data;

      addToast({
        type: 'error',
        title: 'Operação negada',
        description: message,
      });
      handleClose();
      setIsDisabled(false);
    }
  }, [addToast, produto_id, handleSetHasProductUpdated, descricao]);

  return (
    <div>
      <MenuOptionButton type="button" onClick={handleOpen}>
        Excluir Produto
      </MenuOptionButton>

      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <ModalWrapper>
            <div className="header">
              <h1>Atenção</h1>

              <button type="button" onClick={handleClose}>
                <RiCloseLine size={30} />
              </button>
            </div>

            <div className="description">
              <span>
                {tipo_produto === 2
                  ? `Isto irá excluir a matéria prima ${descricao}. `
                  : `Isto irá excluir o produto ${descricao} e seus demais dados. `}
                Deseja confirmar?
              </span>
            </div>

            <div className="btnActions">
              <button
                type="button"
                className="confirm"
                onClick={handleDeleteProduct}
                disabled={isDisabled}
              >
                Confirmar
              </button>

              <button type="button" className="cancel" onClick={handleClose}>
                Cancelar
              </button>
            </div>
          </ModalWrapper>
        </Fade>
      </Modal>
    </div>
  );
};

export default DeleteProductOption;
